import React from "react";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import { trackVideoPlaybackURL } from "../../shared/urls/clientapi";
import { callService, POST } from "../../shared/serviceInvoker";
import ReactGA from 'react-ga';
import { trackEvent } from '../../shared/tracking';

export default class VideoJSPlayer extends React.Component {
    constructor() {
        super();
        this.state = {
            maxPlayTime: 0,
            videoDuration: 0
        };
    }

    componentDidMount() {
        this.player = videojs(this.videoNode, this.props, this.playerReady);
        this.player.on("playing", this.videoPlaying);
        this.player.on("pause", this.videoPause);
        this.player.on("ended", this.videoEnded);
        this.player.on("timeupdate", this.videoTimeUpdate);
        this.player.on("seeking", this.videoSeeking);
        this.player.on("ratechange", this.videoRateChange);
        this.player.on("loadedmetadata", this.videoLoadedMetadata);
        this.setState({maxPlayTime: this.props.maxPlayTime})
    }
    
    playerReady = () => {
        // console.log('------- onPlayerReady -------')
    }

    videoPlaying = () => {
        this.trackVideoPlayback('playing');
    }

    videoPause = () => {
        this.trackVideoPlayback('pause');
    }

    videoEnded = () => {
        this.trackVideoPlayback('ended');
        if (this.props.onVideoEnded !== undefined){
            this.props.onVideoEnded();
        }         
    }

    videoRateChange = () => {        
        let src = this.player.currentSrc();
        let currentTime = this.player.currentTime();
        let duration = this.state.videoDuration;
        let playbackRate = this.player.playbackRate();
        let event_value = `${currentTime} seconds of ${duration} seconds at ${playbackRate}X playback rate`
        ReactGA.event({
            category: 'Video Playback',
            action: 'playback rate change',
            });
        trackEvent('Video Playback', 'playback rate change', src, event_value, '/overview');     
    }

    videoTimeUpdate = () => {
        if (!this.player.seeking()) {
            let seconds = Math.max(this.state.maxPlayTime, this.player.currentTime());
            this.setState({ maxPlayTime: seconds });
        }
    }

    videoSeeking = () => {
        if (this.player.currentTime() > this.state.maxPlayTime) {
            this.player.currentTime(this.state.maxPlayTime);
        }
    }

    videoLoadedMetadata = () => {
        this.setState({videoDuration: this.player.duration()})
    }

    trackVideoPlayback(status) {
        if (sessionStorage.getItem("contact_id")) {
            let contact_id = sessionStorage.getItem("contact_id");
            let bodyFormData = new FormData();
            let src = this.player.currentSrc();
            let currentTime = this.player.currentTime();
            let duration = this.state.videoDuration;
            let playbackRate = this.player.playbackRate();
            bodyFormData.append('src', src);
            bodyFormData.append('event', status);
            bodyFormData.append('currentTime', currentTime);
            bodyFormData.append('duration', duration);
            callService(POST, trackVideoPlaybackURL.replace('{contact_id}', contact_id), bodyFormData, response => {
                let event_value = `${currentTime} seconds of ${duration} seconds at ${playbackRate}X playback rate`
                ReactGA.event({
                    category: 'Video Playback',
                    action: status,
                  });
                trackEvent('Video Playback', status, src, event_value, '/overview');                
            }, error => {
            });
        }
    }

    componentWillUnmount() {
        if (this.player) {
            this.player.dispose();
        }
    }

    pauseVideoFromParent(){
        this.player.pause()
        this.trackVideoPlayback('pause');
    }

    setMaxPlayTimeFromParent(seconds){
        this.setState({maxPlayTime: seconds});
    }

    render() {
        return (
            <div>
                <div data-vjs-player>
                    <video
                        ref={node => (this.videoNode = node)}
                        className="video-js"
                        data-setup='{"fluid": true, "playbackRates": [1, 1.5]}'
                    />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/VideoJSPlayer/index.js